export const enum WebRTCEventTypes {
  SESSION_SUCCEEDED,
  SESSION_DESTROYED,
  REMOTE_JOINED,
  LOCAL_STREAM,
  REMOTE_STREAM,
  MEDIA_STATE_CHANGED,
  FORCE_SHARE_SCREEN_CHANGE,
  REMOTE_LEAVED,
  DEVICE_LISTED,
  SHARE_SCREEN_FIXED,
  ROOM_CREATED,
  JANUS_ERROR
}

export const enum WebRTCProviderEventTypes {
  WEB_RTC_CREATED
}

export const JanusErrorCodes = {
  NO_SUCH_ROOM: 426
}
